var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNumber = function SvgNumber(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#003595"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FDFDFD",
    fillRule: "evenodd",
    d: "M6.935 19.844a.43.43 0 0 1-.148-.39l.51-3.168h-2.68a.64.64 0 0 1-.443-.156.53.53 0 0 1-.174-.416v-.83a.53.53 0 0 1 .174-.417.64.64 0 0 1 .442-.155h2.975l.697-4.624H5.313a.64.64 0 0 1-.442-.156.53.53 0 0 1-.174-.415v-.831a.53.53 0 0 1 .174-.416.64.64 0 0 1 .442-.156H8.61l.482-3.169a.77.77 0 0 1 .215-.39A.56.56 0 0 1 9.709 4h.91q.243 0 .403.156a.44.44 0 0 1 .134.39l-.483 3.168h4.02l.483-3.169a.77.77 0 0 1 .214-.39.56.56 0 0 1 .402-.155h.911q.242 0 .402.156a.44.44 0 0 1 .134.39l-.482 3.168h2.653a.6.6 0 0 1 .43.156q.16.156.16.416v.83a.55.55 0 0 1-.16.416.6.6 0 0 1-.43.156h-2.948l-.697 4.624h2.949a.6.6 0 0 1 .428.155q.162.156.161.416v.831a.55.55 0 0 1-.16.416.6.6 0 0 1-.43.156h-3.27l-.482 3.168a.77.77 0 0 1-.214.39.56.56 0 0 1-.402.156h-.911q-.242 0-.416-.156a.43.43 0 0 1-.147-.39l.51-3.168H9.36l-.483 3.168a.77.77 0 0 1-.215.39.56.56 0 0 1-.402.156h-.91q-.242 0-.416-.156m2.747-5.532h3.993l.697-4.624h-3.993z",
    clipRule: "evenodd"
  })));
};
export default SvgNumber;